import GuestBook from "@/components/sections/GuestBook";

export default function GuestBookPage() {
  return (
    <div className="pt-16 min-h-screen bg-wc-cream">
      <GuestBook />
    </div>
  );
}
